import { createFileRoute, Outlet } from "@tanstack/react-router";

/** Staff and roles: the list, and one staff member's page. */
export const Route = createFileRoute("/_app/settings/staff")({
  component: Outlet,
});
